import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mariana G.',
    text: 'Me pasaba que arrancaba el día bien y a la tarde terminaba súper hinchada aunque comiera sano. Después de unos días siguiendo la guía empecé a notar muchísima diferencia.'
  }, {
    name: 'Laura P.',
    text: 'Lo que más me ayudó fue entender qué cosas me estaban inflamando sin darme cuenta.'
  }, {
    name: 'Sofía R.',
    text: 'Volví a sentirme cómoda con ropa que ya evitaba usar.'
  }];
  return <section className="w-full bg-white py-14 px-4 md:px-8" data-id="element-231">
      <div className="max-w-5xl mx-auto" data-id="element-232">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-2xl md:text-3xl font-serif text-text-dark text-center mb-8" data-id="element-233">
          Miles de mujeres ya están sintiéndose más livianas
        </motion.h2>

        <div className="grid sm:grid-cols-3 gap-5" data-id="element-234">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="bg-bg-soft p-6 rounded-2xl border border-secondary-light/20" data-id="element-235">
              <div className="flex items-center gap-0.5 mb-3" data-id="element-236">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-237" />)}
              </div>
              <p className="text-primary-mid text-sm leading-relaxed mb-4" data-id="element-238">
                "{t.text}"
              </p>
              <p className="text-xs text-primary-mid/60 font-medium" data-id="element-239">
                — {t.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}